import { MinorUser, Ssn, User } from '@digila-ui/types'
import {
  AcceptApplicationRequest,
  AddMinorToHouseholdRequest,
  CreateApplicationRequest,
  DigiLaFlow,
  ENDPOINT_DIGILA_ACCEPT_APPLICATION,
  ENDPOINT_DIGILA_ADD_MINOR_TO_HOUSEHOLD,
  ENDPOINT_DIGILA_CREATE_APPLICATION,
  ENDPOINT_DIGILA_GET_MINOR_USER_INFO,
  ENDPOINT_DIGILA_GET_USER_INFO,
  ENDPOINT_DIGILA_REJECT_APPLICATION,
  ENDPOINT_DIGILA_UPDATE_GUARDIAN_KYC_INFO,
  ENDPOINT_DIGILA_UPDATE_MINOR_KYC_INFO,
  ENDPOINT_DIGILA_VERIFY_AUTH_CODE,
} from '@shared/digila'
import { UpdateBankCustomerResponse, VerifyAuthCodeResponse } from '@shared/types'
import { getKycInfoRequest } from '@ui-common/kyc/utils'
import { SummaryInfoStepContext } from '@ui-common/kyc/wizard/steps/summary-info/summaryInfoStepMachine'
import { YesNo } from '@ui-common/types'
import { callEndpoint } from '@ui-common/utils/http/client'
import { getLanguage } from '@ui-common/utils/language'

import { AoMembershipFormData } from '../components/ServiceWizard/AoMembership/types'
import { getDigilaSourceChannel } from '../utils/helpers'

export const getUserInfo = (): Promise<User> => callEndpoint(ENDPOINT_DIGILA_GET_USER_INFO)
export const getMinorUserInfo = (minorSsn: Ssn): Promise<MinorUser> =>
  callEndpoint(ENDPOINT_DIGILA_GET_MINOR_USER_INFO, { requestPayload: { minorSsn } })

export const verifyAuthCode: (authCode: string) => Promise<VerifyAuthCodeResponse> = (authCode) =>
  callEndpoint(ENDPOINT_DIGILA_VERIFY_AUTH_CODE, {
    requestPayload: {
      sourceChannel: getDigilaSourceChannel(),
      authCode,
      uiLanguage: getLanguage(),
      flow: DigiLaFlow.Default,
    },
  })

export const updateGuardianKycInfo: (input: SummaryInfoStepContext) => Promise<UpdateBankCustomerResponse> = async (
  input,
) => {
  const requestPayload = getKycInfoRequest(input, true)
  return callEndpoint(ENDPOINT_DIGILA_UPDATE_GUARDIAN_KYC_INFO, { requestPayload })
}

export const updateMinorKycInfo: (input: SummaryInfoStepContext) => Promise<UpdateBankCustomerResponse> = async (
  input,
) => {
  const requestPayload = getKycInfoRequest(input, false)
  return callEndpoint(ENDPOINT_DIGILA_UPDATE_MINOR_KYC_INFO, { requestPayload })
}

export const addMinorToHousehold = async (formData: AoMembershipFormData): Promise<void> => {
  const aoRequest: AddMinorToHouseholdRequest = {
    orderScard: formData.orderCard === YesNo.Yes,
    consent: formData.aoHouseholdConsent,
  }
  return callEndpoint(ENDPOINT_DIGILA_ADD_MINOR_TO_HOUSEHOLD, { requestPayload: aoRequest })
}

export const sendData = async (request: CreateApplicationRequest): Promise<void> => {
  return callEndpoint(ENDPOINT_DIGILA_CREATE_APPLICATION, { requestPayload: request })
}

export const acceptApplication = async (request: AcceptApplicationRequest): Promise<void> => {
  return callEndpoint(ENDPOINT_DIGILA_ACCEPT_APPLICATION, { requestPayload: request })
}

export const rejectApplication = async (): Promise<void> => {
  return callEndpoint(ENDPOINT_DIGILA_REJECT_APPLICATION)
}
